import { EventPost } from '../events.helper'

/**
 * The stored Quill description for the event's own event type, with non-breaking spaces flattened
 * to ordinary ones so `overflow-wrap` can break long unspaced text in the view modal. Read mode
 * only — the editable value the user saves is untouched.
 *
 * Returns undefined when the event carries no description for its event type: an event may have no
 * `input_field` at all, or one holding only the other event type's description.
 *
 * The result is unsanitized backend HTML. Callers must pass it through `DOMPurify.sanitize` before
 * it reaches the DOM.
 */
export function getEventDescriptionHtml(
  eventPost: Pick<EventPost, 'input_field' | 'operational_event_type'>
): string | undefined {
  const eventType = eventPost.operational_event_type
  const rawHtml = eventType ? eventPost.input_field?.[eventType] : undefined

  return rawHtml?.replace(/&nbsp;| /g, ' ')
}
